import React from 'react';

import sanitizeHtml from 'sanitize-html';

import './RichTextContent.styles.css';

type RichTextContentProps = {
  content: string;
  className?: string;
};

const RichTextContent: React.FC<RichTextContentProps> = ({ content, className }) => {
  if (!content) return null;

  // Sanitize HTML with options that allow Quill formatting
  const sanitizedContent = sanitizeHtml(content, {
    allowedTags: ['p', 'br', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'ul', 'ol', 'li', 'a', 'blockquote'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    transformTags: {
      a: (tagName, attribs) => ({
        tagName: 'a',
        attribs: {
          ...attribs,
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      }),
    },
  });

  return (
    // eslint-disable-next-line react/no-danger
    <div className={`rich-text-content ${className || ''}`} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
  );
};

export default RichTextContent;
